import React from 'react'
import { useSelector } from 'react-redux';
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardSubtitle,
  CardFooter
} from "@progress/kendo-react-layout";
import format from 'date-fns/format';
import isNil from 'lodash/isNil';
import { getOrderSupportRequestsStatuses } from 'src/slices/orderSupportRequestsStatuses'
import './style.scss'

const ItemRenderer = ({ dataItem }) => {

  const statuses = useSelector(getOrderSupportRequestsStatuses);
  const authorName = dataItem?.author?.name;

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>{authorName}</CardTitle>
          <CardSubtitle>{format(dataItem.createdAt, 'MM/DD/YYYY HH:mm')}</CardSubtitle>
        </CardHeader>
        <CardBody>
          {dataItem.text}
        </CardBody>
        {!isNil(dataItem.newStatus) &&
          <CardFooter>
            <CardSubtitle>{authorName} has changed status to <b>{statuses.find(x => x.value === dataItem.newStatus)?.description}</b> </CardSubtitle>
          </CardFooter>
        }
      </Card>
    </>
  );
}

export default ItemRenderer;